import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class LastModifiedColumn extends Column {
    title = 'employees.records.lastModified';
    property = 'updatedAt';
    type: CellDisplay = CellDisplay.date;
    sortable = true;
}
